export interface InsuredObject {
    id?: number;
    person?: string | number;
    description?: string | number;
    detail?: string | number;
    value?: string | number;
    date?: string | number;
    type?: string | number;
    model?: string | number;
}

export interface InsuredObjectDto {
    Id?: number;
    Person?: string | number;
    ObjectDescription?: string | number;
    ObjectDetail?: string | number;
    ObjectValue?: string | number;
    ObjectDate?: string | number;
    ObjectType?: string | number;
    ObjectModel?: string | number;
}

export function insuredObjectToDto(object: InsuredObject): InsuredObjectDto {
    return {
        Id: object.id,
        ObjectDate: object.date,
        ObjectDescription: object.description,
        ObjectDetail: object.detail,
        ObjectValue: object.value,
        Person: object.person,
        ObjectModel: object.model,
        ObjectType: object.type,
    };
}
